module.exports = __webpack_public_path__ + "media/megamenu/Mosaics-39565b7d.jpg";